import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export interface ContextMenuItem {
  readonly label: string;
  readonly icon?: string;
  readonly action: () => void;
}

/**
 * Renders een eenvoudige verticale lijst van context-menu items. Wordt
 * door {@link ContextMenuService} dynamisch in een CDK Overlay gemount.
 * Item-clicks bubble'n via {@link itemSelected} terug naar de service die
 * dan sluit en het `action()`-callback uitvoert.
 */
@Component({
  selector: 'context-menu',
  templateUrl: './context-menu.component.html',
  styleUrl: './context-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'role': 'menu',
  },
})
export class ContextMenuComponent {
  readonly items = input.required<readonly ContextMenuItem[]>();
  readonly itemSelected = output<ContextMenuItem>();

  protected onItemClick(event: MouseEvent, item: ContextMenuItem): void {
    event.preventDefault();
    event.stopPropagation();
    this.itemSelected.emit(item);
  }
}
